import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import EmassDashboard from '../../common/buttons/emassDash';
import { useNavigate } from 'react-router-dom';

export default function EnterpriseOverview() {

  const baseRoute = process.env.REACT_APP_BASE_RpmOUTE || '/';
  const imgRoute0 = 'images/analytics/enterprise-0.png';
  const imgRoute1 = 'images/analytics/enterprise-1.png';
  const imgRoute2 = 'images/analytics/enterprise-2.png';
  const imgRoute3 = 'images/analytics/enterprise-3.png';
  const route0 = baseRoute + imgRoute0;
  const route1 = baseRoute + imgRoute1;
  const route2 = baseRoute + imgRoute2;
  const route3 = baseRoute + imgRoute3;
  const navigate = useNavigate();
  const handleResponse = (() => {
    navigate('/enterpriseDetails')
  });
  
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        Enterprise Overview
      </Typography>
      <EmassDashboard></EmassDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="Enterprise title"
          src={route0}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '10px', marginBottom: '-60px'}}
      />
      <img 
          alt="Enterprise Info"
          src={route1}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-110px', marginLeft:'13px' }}
      />
      <img 
          alt="Enterprise Info 2"
          src={route2}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-100px' }}
      />
      <img 
          alt="Enterprise Info 3"
          src={route3}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-50px' }}
      />
      <Button
        onClick={handleResponse}
        sx={{ 
          fontSize: '0.7rem',
          marginRight: "1080px", 
          marginTop: '-65px',
          color: '#FFF', 
          bgcolor: '#606662' , 
          height: '22px', 
          '&:hover': {
              backgroundColor: '#1f1e1d',
          } }}>
        system_192
      </Button>
      </Box>
    </Container>
  );
};